var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_957_274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9971 4.25C27.2216 6.65975 29.9971 11.2885 29.9971 16.5C29.9971 19.2689 29.176 21.9757 27.6376 24.278C26.0993 26.5803 23.9128 28.3747 21.3546 29.4343C18.7965 30.4939 15.9815 30.7712 13.2658 30.231C10.5501 29.6908 8.05552 28.3574 6.09758 26.3995C4.13965 24.4416 2.80628 21.947 2.26608 19.2313C1.72589 16.5155 2.00314 13.7006 3.06276 11.1424C4.12239 8.58426 5.9168 6.39776 8.21909 4.85942C10.5214 3.32109 13.2281 2.5 15.9971 2.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9971 10.6667V3.66669H29.9971",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_957_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(-0.00292969 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.bebe40f3cd6097d1a722c3e3514a6e4c.svg";
export { ForwardRef as ReactComponent };